<template>
  <div>
    <!-- langs explained and selection -->
    <b-field :label="$t('languages')" />
    <b-message class="is-primary">
      {{ $t("languagesExplained") }}
    </b-message>
    <b-field v-for="lang in langComb" :key="lang._sortId" grouped group-multiline>
      <LanguagePicker
        v-model="lang.lang1"
        class="control min-width-300"
        :blacklist="[lang.lang2]"
        :change-local="false"
        :loading="false"
        :disabled="!editable"
      />
      <b-tooltip type="is-primary" class="control" :label="$t(lang.mono ? 'monodirectional' : 'bidirectional')">
        <b-button
          :icon-left="lang.mono ? 'arrow-right-bold' : 'arrow-left-right-bold'"
          :disabled="!editable"
          @click="lang.mono = !lang.mono"
        />
      </b-tooltip>
      <LanguagePicker
        v-model="lang.lang2"
        class="control min-width-300"
        :blacklist="[lang.lang1]"
        :change-local="false"
        :loading="false"
        :disabled="!editable"
      />
      <b-button class="is-primary control" icon-right="pencil-outline" @click="editModal(lang._sortId)">
        {{ $t("editTranslationServices") }}
      </b-button>
      <p>
        <b-button v-if="editable" class="is-danger" @click="removeLangCombo(lang._sortId)">
          <b-icon icon="delete" />
        </b-button>
      </p>
    </b-field>
    <b-field class="mt-0" group-multiline grouped>
      <b-button
        v-if="editable && langComb.length < 15"
        class="is-primary control"
        :disabled="addLangBtnDisable"
        icon-left="plus"
        @click="addLangCombo"
      >
        {{ $t("addLangCombo") }}
      </b-button>
    </b-field>
    <!-- For recording option -->
    <!-- <div v-if="Object.keys(recordLangs).length > 0" class="mb-6">
      <hr />
      <b-field :label="$t('recordTitle2')" v-if="subscriptionDetails" />
      <b-field :label="$t('recordTitle')" v-else />
      <b-field
        grouped
        group-multiline
        class="control"
        v-for="recordLang in recordLangs"
        :key="recordLang.lang"
      >
        <LanguagePicker
          :value="recordLang.lang"
          class="control min-width-300"
          disabled
        />
        <b-switch class="control" type="is-danger" v-model="recordLang.record">
          {{ $t("recordLang") }}
          <b-icon type="is-danger" size="is-small" icon="record"></b-icon>
        </b-switch>
      </b-field>
    </div> -->
    <b-field>
      <b-modal
        :active.sync="modalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        :can-cancel="false"
        aria-role="dialog"
        aria-modal
      >
        <TranslationWizardModal v-model="modalData" :editable="editable" />
      </b-modal>
    </b-field>
    <b-field v-if="invitedTranslators.length > 0" :label="$t('invitedTranslators')" />
    <b-message v-if="invitedTranslators.length > 0" type="is-primary">
      {{ $t("invitedTranslatorsExplained") }}
    </b-message>
    <div v-if="invitedTranslators.length > 0" class="mb-6">
      <b-button v-for="(t, i) in invitedTranslators" :key="i" class="mr-2" @click="editModal(t._sortId)">
        <b>{{ t.lang1 }}</b
        ><b-icon
          style="vertical-align: bottom; margin: 0 0.1em"
          :icon="t.mono ? 'arrow-right-bold' : 'arrow-left-right-bold'"
        /><b>{{ t.lang2 }}</b
        ><span class="ml-2">{{ t.mail }}</span>
      </b-button>
    </div>
    <!-- TEMP HIDDEN -->
    <!-- <b-field class="is-hidden-mobile">
      <b-slider
        v-model="maxParticipants"
        class="control"
        :min="minParticipantsLimit"
        :max="maxParticipantsLimit"
        :tooltip="true"
        :disabled="!editable"
        type="is-primary"
        tooltip-type="is-primary"
      >
        <template
          v-for="val in Array.from(
            [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20
            ],
            x => x * 10
          )"
        >
          <b-slider-tick :key="val" :value="val">
            {{ val }}
          </b-slider-tick>
        </template>
      </b-slider>
      <br /><br />
    </b-field> -->
    <!-- <b-switch
      v-if="subscriptionDetails == undefined"
      v-model="techSupport"
      class="my-3"
      :disabled="!editable"
    >
      <b-field
        :label="
          `${$t('techSupport')} ${intl.format(
            $store.state.organizationData.conditions.techSupportPerHour
          )}\/h`
        "
      />
    </b-switch> -->
    <b-field v-if="!subscriptionDetails && !isSubscriptionTrialRunning" :label="$t('techSupport')" />
    <b-message v-if="!subscriptionDetails && !isSubscriptionTrialRunning" class="is-primary mb-4">
      {{ $t("techSupportExplained") }}
    </b-message>
  </div>
</template>

<script>
import LanguagePicker from "@/components/LanguagePicker";
import { db } from "@/firebase";
import TranslationWizardModal from "@/components/eventWizard/TranslationWizardModal";
import moment from "moment";
import { v4 } from "uuid";
import cloneDeep from "clone-deep";
import isTrialRunning from "./utils";

export default {
  name: "Translation",
  components: {
    LanguagePicker,
    TranslationWizardModal,
  },
  props: {
    draftLangComb: {
      type: Array,
      default: null,
    },
    organizationId: {
      type: String,
      default: "",
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modalActive: false,
      modalData: null,
      langComb: [],
      trialSubscriptionDetails: null,
      moment,
      firebaseOrg: {},
    };
  },
  firestore() {
    return {
      firebaseOrg: db.collection("organizations").doc(this.$route.params.organizationId),
    };
  },
  computed: {
    subscriptionDetails() {
      const orgData = JSON.parse(JSON.stringify(this.firebaseOrg));
      return orgData?.subscriptionDetails;
    },
    addLangBtnDisable() {
      if (this.isSubscriptionTrialRunning && this.langComb.length > 0) {
        return true;
      }
      return false;
    },
    isSubscriptionTrialRunning() {
      const organizationDoc = JSON.parse(JSON.stringify(this.firebaseOrg));

      return isTrialRunning(organizationDoc);
    },
    intl() {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: this.$store.state.organizationData.conditions.currency
          ? this.$store.state.organizationData.conditions.currency
          : "EUR",
      });
    },
    techSupport: {
      get() {
        return this.$store.state.draft.techSupport;
      },
      set(value) {
        this.$store.commit("SET_DRAFT_FIELD", ["techSupport", value]);
      },
    },
    langs: {
      get() {
        let langs = [];
        for (let comb of this.langComb) {
          if (comb.lang1 === "" || comb.lang2 === "") {
            break;
          }
          langs.push(comb.lang1);
          langs.push(comb.lang2);
        }
        return [...new Set(langs)];
      },
    },
    recordLangs() {
      let recordLangs = {};
      for (let lang of this.langs) {
        if (this.$store.state.draft.recordLangs[lang]) {
          recordLangs[lang] = {
            lang: lang,
            record: this.$store.state.draft.recordLangs[lang].record,
          };
        } else {
          recordLangs[lang] = {
            lang: lang,
            record: false,
          };
        }
      }
      this.$store.commit("SET_DRAFT_FIELD", ["recordLangs", recordLangs]);
      return recordLangs;
    },
    eventTimes() {
      return this.$store.state.draft.eventTimes;
    },
    operatingHours() {
      return this.eventTimes.reduce(
        (acc, timeslot) => Math.ceil(moment(timeslot.endTime).diff(timeslot.startTime, "minutes") / 60) + acc,
        0,
      );
    },
    invitedTranslators() {
      return (
        Array.isArray(this.langComb)
          ? this.langComb.map((lc) =>
              Array.isArray(lc.translatorEmails) ? lc.translatorEmails.map((t) => ({ mail: t, ...lc })) : [],
            )
          : []
      )
        .flat()
        .concat(
          this.langComb
            .filter((lc) => lc.da24 && lc.lang1 && lc.lang2)
            .map((lc) => ({ mail: this.$t("requestedViaQonda"), ...lc })),
        );
    },
  },
  watch: {
    // load data from draft
    draftLangComb() {
      if (this.langComb.length == 0) {
        this.draftLangComb.forEach((lang) => {
          this.addLangCombo(lang);
        });
      }
    },
    // only send valid dates up to the draft
    langComb: {
      deep: true,
      handler(langComb) {
        let langCombCopy = cloneDeep(langComb);
        let eventDays = this.eventTimes.map((y) => moment(y.date).format("YYYY-MM-DD"));
        let validLangComb = langCombCopy.filter(
          (y) => y.lang1 && y.lang2 && y.lang1.length == y.lang2.length && y.lang1.length == 3,
        );
        let validLangCombEmptyRemoved = validLangComb.map((y) => {
          // for each combination go through all timeslots
          let timeslotDays = y.timeslots.map((z) => moment(z.startTime).format("YYYY-MM-DD"));
          let removedTimeslots = timeslotDays.filter((z) => !eventDays.includes(z));
          // filter those out which are not possible
          y.timeslots = y.timeslots.filter((z) => !removedTimeslots.includes(moment(z.startTime).format("YYYY-MM-DD")));
          delete y["_sortId"];
          return y;
        });
        this.$store.commit("SET_DRAFT_FIELD", ["langComb", validLangCombEmptyRemoved]);
      },
    },
    eventTimes(eventTimes) {
      // filters out impossible timeslots, if they are on days that have been removed from the eventTimes list
      let eventDays = eventTimes.map((y) => moment(y.date).format("YYYY-MM-DD"));
      this.langComb.forEach((lang) => {
        let timeslotDays = lang.timeslots.map((y) => moment(y.startTime).format("YYYY-MM-DD"));
        let removedTimeslots = timeslotDays.filter((y) => !eventDays.includes(y));
        lang.timeslots = lang.timeslots.filter(
          (y) => !removedTimeslots.includes(moment(y.startTime).format("YYYY-MM-DD")),
        );
      });
    },
  },
  methods: {
    editModal(key) {
      let langIndex = this.langComb.findIndex((y) => y._sortId == key);
      let data = this.langComb[langIndex];
      if (data.lang1 && data.lang2) {
        this.modalData = data;
        this.modalActive = true;
      } else {
        this.$buefy.toast.open({
          type: "is-warning",
          message: this.$t("pleaseSelectLanguages"),
        });
      }
    },
    addLangCombo(lang = {}) {
      if (this.isSubscriptionTrialRunning && this.langComb.length === 0) {
        this.langComb.push({
          lang1: lang.lang1 || "",
          lang2: lang.lang2 || "",
          mono: typeof lang.mono === "undefined" ? true : lang.mono,
          timed: typeof lang.timed === "undefined" ? false : lang.timed,
          da24: typeof lang.da24 === "undefined" ? false : lang.da24,
          translatorEmails: lang.translatorEmails || [],
          timeslots: lang.timeslots || [],
          _sortId: v4(),
        });
      } else if (!this.isSubscriptionTrialRunning) {
        this.langComb.push({
          lang1: lang.lang1 || "",
          lang2: lang.lang2 || "",
          mono: typeof lang.mono === "undefined" ? true : lang.mono,
          timed: typeof lang.timed === "undefined" ? false : lang.timed,
          da24: typeof lang.da24 === "undefined" ? false : lang.da24,
          translatorEmails: lang.translatorEmails || [],
          timeslots: lang.timeslots || [],
          _sortId: v4(),
        });
      }
    },
    removeLangCombo(key) {
      this.$delete(
        this.langComb,
        this.langComb.findIndex((y) => y._sortId == key),
      );
      if (this.langComb.length == 0) {
        this.addLangCombo();
      }
    },
  },
};
</script>

<style></style>
